/**
 * Trả về nội dung Nghị định tương ứng dựa trên ngày lập tờ khai.
 * - Từ ngày 01/07/2026 trở đi: Áp dụng Nghị định số 254/2026/NĐ-CP ngày 30/06/2026
 * - Trước ngày 01/07/2026: Áp dụng Nghị định số 123/2020/NĐ-CP ngày 19/10/2020
 * 
 * @param dateCreate Ngày lập tờ khai (Date | string | number)
 * @returns Nội dung Nghị định phù hợp
 */
export const getDecreeText = (dateCreate?: any): string => {
  console.log("DEBUG getDecreeText input:", dateCreate, "type:", typeof dateCreate);
  if (!dateCreate) {
    // Nếu chưa có ngày lập, mặc định sử dụng Nghị định 123
    return 'Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:';
  }

  let date: Date;

  // Hỗ trợ đối tượng moment
  if (dateCreate && typeof dateCreate === 'object' && typeof dateCreate.toDate === 'function') {
    date = dateCreate.toDate();
  } else if (dateCreate instanceof Date) {
    date = dateCreate;
  } else if (typeof dateCreate === 'string') {
    // Hỗ trợ định dạng dd/mm/yyyy
    if (dateCreate.includes('/')) {
      const parts = dateCreate.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        date = new Date(year, month, day);
      } else {
        date = new Date(dateCreate);
      }
    } else {
      date = new Date(dateCreate);
    }
  } else {
    date = new Date(dateCreate);
  }

  // Nếu parse không thành công, fallback về Nghị định 123
  if (isNaN(date.getTime())) {
    console.log("DEBUG getDecreeText parsed Invalid Date");
    return 'Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:';
  }

  // Mốc 01/07/2026 00:00:00 (Tháng 7 là index 6 trong JS Date)
  const compareDate = new Date(2026, 6, 1, 0, 0, 0, 0);
  const isGreaterOrEqual = date.getTime() >= compareDate.getTime();
  console.log("DEBUG getDecreeText parsed date:", date, "compareDate:", compareDate, "result >=:", isGreaterOrEqual);

  if (isGreaterOrEqual) {
    return 'Theo nghị định số 254/2026/NĐ-CP ngày 30 tháng 06 năm 2026 của Chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:';
  }

  return 'Theo nghị định số 123/2020/NĐ-CP ngày 19 tháng 10 năm 2020 của chính phủ, chúng tôi/tôi thuộc đối tượng sử dụng hóa đơn điện tử. Chúng tôi/tôi đăng ký/thay đổi thông tin đã đăng ký với cơ quan thuế về việc sử dụng hóa đơn điện tử như sau:';
};
